// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimCard-cls1_vHT","cls2":"ClaimCard-cls2_LpJ ClaimCard-cls1_vHT"};